export default __webpack_public_path__ + "static/media/loading.bdb7f730.gif";